<ng-container>
  <main role="main" id="content" class="pre-loader">
    <section>
      <mat-spinner diameter="65"></mat-spinner>
      <p>Connecting to AmiLearn</p>
    </section>
  </main>
</ng-container>
